// Vendors
import { Theme } from '@equisoft/design-elements-react';

// Src
import { DSThemeCore, IThemeInfo } from '../core';
import colors from './colors';

const dsThemeCore: Theme = DSThemeCore(colors);
const DSTheme: Theme = {
    ...dsThemeCore,
};

const customThemeImports: IThemeInfo = {
    designElements: DSTheme,
    colors: colors,
};

export default customThemeImports;
